var _path, _g, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 206,
    viewBox: "0 0 203 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.527 3.32129C149.829 3.32129 188.986 42.4773 188.986 90.7793C188.986 139.081 149.829 178.238 101.527 178.238C53.2254 178.238 14.0693 139.081 14.0693 90.7793C14.0695 42.4775 53.2255 3.32149 101.527 3.32129Z",
    stroke: "#EBEDF0",
    strokeWidth: 1.76684
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14877_114847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.56 100.234L118.769 108.798L116.057 111.628L107.85 103.062C104.796 105.616 100.998 107.006 97.084 107C87.562 107 79.834 98.936 79.834 89C79.834 79.064 87.562 71 97.084 71C106.606 71 114.334 79.064 114.334 89C114.34 93.084 113.008 97.0475 110.56 100.234ZM106.715 98.75C109.148 96.1398 110.506 92.6409 110.501 89C110.501 81.264 104.496 75 97.084 75C89.6703 75 83.6673 81.264 83.6673 89C83.6673 96.734 89.6703 103 97.084 103C100.573 103.006 103.926 101.588 106.428 99.05L106.715 98.75V98.75Z",
    fill: "#98A1B0"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 48.6746V58.7643C35 59.723 34.2585 60.5 33.3443 60.5H6.65567C5.74127 60.5 5 59.7144 5 58.7369V37.75H15C15.9205 37.75 16.6667 36.9665 16.6667 36V25.5H33.3362C34.2552 25.5 35 26.2968 35 27.2357V33.8254L20.002 49.5733L19.9917 56.9913L27.069 57.0021L35 48.6746ZM36.297 37.4133L38.654 39.8881L25.6903 53.5L23.3298 53.4963L23.3333 51.0252L36.297 37.4133ZM5 34.25L13.3333 25.5056V34.25H5Z",
    fill: "#4E4B66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M185 51.6746V61.7643C185 62.723 184.258 63.5 183.344 63.5H156.656C155.741 63.5 155 62.7144 155 61.7369V40.75H165C165.92 40.75 166.667 39.9665 166.667 39V28.5H183.336C184.255 28.5 185 29.2968 185 30.2357V36.8254L170.002 52.5733L169.992 59.9913L177.069 60.0021L185 51.6746ZM186.297 40.4133L188.654 42.8881L175.69 56.5L173.33 56.4963L173.333 54.0252L186.297 40.4133ZM155 37.25L163.333 28.5056V37.25H155Z",
    fill: "#4E4B66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114 184.675V194.764C114 195.723 113.258 196.5 112.344 196.5H85.6557C84.7413 196.5 84 195.714 84 194.737V173.75H94C94.9205 173.75 95.6667 172.966 95.6667 172V161.5H112.336C113.255 161.5 114 162.297 114 163.236V169.825L99.002 185.573L98.9917 192.991L106.069 193.002L114 184.675ZM115.297 173.413L117.654 175.888L104.69 189.5L102.33 189.496L102.333 187.025L115.297 173.413ZM84 170.25L92.3333 161.506V170.25H84Z",
    fill: "#4E4B66"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14877_114847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 48,
    fill: "white",
    transform: "translate(76 67)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchNotes);
export default __webpack_public_path__ + "static/media/SearchNotes.4f8319f91a4e53e85c6dca3d8fbd2b65.svg";
export { ForwardRef as ReactComponent };